import { injectGlobal } from 'styled-components';
import Webfont from 'webfontloader';

const fontFamily = 'Roboto';

// eslint-disable-next-line
injectGlobal`
  * {
    box-sizing: border-box;
  }

  html, body {
    width: 100%;
    margin: 100%;
    margin: 0;
    padding: 0;
  }

  body, button, input, textarea, select {
    font-family: ${fontFamily}, sans-serif;
  }
`;

Webfont.load({
  google: {
    families: [`${fontFamily}:300,400,400i,500`],
  },
});



// WEBPACK FOOTER //
// ./src/utils/injectStyles.js